import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../../../app/redux/hooks';
import { getCurrentToken } from '../../../../firebase';
import { getLogin, getRoleAccess } from '../../../redux/reducer/commonSlices/loginSlice';
import { useNavigate } from 'react-router-dom';
import { createTheme, styled, Switch, useMediaQuery } from '@mui/material';
import { getMyProfileAction } from '../../../redux/reducer/commonSlices/myProfileSlice';
import { debounce, useAbort } from '../../../../utils/commonFunctions';

export const useLoginFormSubmission = () => {
  const dispatch = useAppDispatch();
  const [isKeepSignedIn, setIsKeepSignedIn] = useState<boolean>(true);
  const navigate = useNavigate();
  const [firbaseLoading, setFirebaseLoading] = useState(false);
  const createAbort = useAbort();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsKeepSignedIn(event.target.checked);
  };

  const handleForgetPw = () => navigate('/forgetpassword');

  const onSubmit = async (params: any) => {
    try {
      // Get the Firebase token
      localStorage.removeItem('status');
      setFirebaseLoading(true);
      const token: any = await getCurrentToken();
      localStorage.setItem('firebaseToken', token);
      let action1 = await dispatch(
        getLogin({
          userID: params.userID,
          password: params.password,
          roleType: 'user',
          firebaseToken: token,
          ...(isKeepSignedIn ? { keepMeLogin: isKeepSignedIn } : {})
        })
      );
      setFirebaseLoading(false);
      if (action1.type === getLogin.fulfilled.type) {
        await dispatch(getRoleAccess(params?.userID));
      }
    } catch (error) {}
  };

  useEffect(() => {
    const key = localStorage.getItem('isKeepSignedIn');
    if (key === 'false') {
      setIsKeepSignedIn(false);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('isKeepSignedIn', `${isKeepSignedIn}`);
  }, [isKeepSignedIn]);
  return {
    onSubmit,
    handleChange,
    isKeepSignedIn,
    handleForgetPw,
    navigate,
    dispatch,
    firbaseLoading
  };
};

export const useLoginStyle = (themes: any) => {
  const theme = createTheme();

  const SmallDevices = useMediaQuery(theme.breakpoints.down('lg'));

  const AntSwitch = styled(Switch)(() => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)'
      }
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: themes === 'ayka' ? '#ff6347' : '#3239EA'
        }
      }
    },
    '& .MuiSwitch-thumb': {
      width: 12,
      height: 12,
      borderRadius: 6
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: '#000',
      boxSizing: 'border-box'
    }
  }));
  return { AntSwitch, SmallDevices };
};

export const useAfterLoginNavigate = () => {
  let lastVisitedPage = localStorage.getItem('lastVisitedPage');
  let token = localStorage.getItem('token');
  let defaultView = localStorage.getItem('defaultView');

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  // const handleNavigate = () => {
  //   if (lastVisitedPage && token) {
  //     dispatch(getMyProfileAction(''));
  //     navigate(lastVisitedPage, { replace: true });
  //   } else if (token) {
  //     dispatch(getMyProfileAction(''));
  //     navigate(`/${defaultView}`);
  //   }
  // };
  useEffect(() => {
    if (lastVisitedPage && token) {
      dispatch(getMyProfileAction(''));
      navigate(lastVisitedPage, { replace: true });
    } else if (token) {
      dispatch(getMyProfileAction(''));
      navigate(`/${defaultView}`);
    }
  }, [lastVisitedPage, token]);
  return { lastVisitedPage, token };
};
